import { GridRenderer } from '../../rendering/GridRenderer.js';
import { Grid } from '../../core/Grid.js';
import { RenderConfig } from '../../rendering/Renderer.js';
import { TutorialGameAdapter } from '../TutorialEngine.js';

class PlainGridRenderer extends GridRenderer {
    render(grid: Grid): void {
        this.clear();
        this.drawGrid();
        this.drawDigits(grid);
    }
}

class PlainGridTutorialAdapter implements TutorialGameAdapter {
    private renderer: PlainGridRenderer;
    private grid: Grid;

    constructor(canvas: HTMLCanvasElement, grid: Grid) {
        this.grid = grid;
        this.renderer = new PlainGridRenderer(canvas, grid);
    }

    applyState(_state: unknown): void {
        // No game state to apply — bare grid only
    }

    render(_options: unknown): void {
        this.renderer.render(this.grid);
    }

    getConfig(): RenderConfig {
        return this.renderer.getConfig();
    }
}

export function createPlainGridTutorialAdapter(
    canvas: HTMLCanvasElement,
    grid: Grid,
): TutorialGameAdapter {
    return new PlainGridTutorialAdapter(canvas, grid);
}
